/**
 * Cart drawer CRO improvements — client-side behaviour.
 * Added 22 Aug 2026.
 *
 * Reservation notice ("Limited stock — items aren't reserved until
 * checkout"). This theme rebuilds .cart__items client-side after
 * add-to-cart or a quantity change (theme.js theme.AjaxProduct /
 * theme.CartForm) using the real server-rendered cart-item.liquid
 * markup, which already carries a data-low-stock="true" attribute on
 * any line at/under the low-stock threshold. So this only needs to
 * check the DOM for that attribute after each cart update — no need
 * to duplicate inventory logic or hit /cart.js (which doesn't expose
 * per-line inventory anyway), kept out of theme.js (large, shared
 * everywhere) the same way cart-free-shipping-bar.js already is.
 */
(function () {
  'use strict';

  function updateReservationNotice() {
    var notice = document.querySelector('[data-reservation-notice]');
    if (!notice) return;
    var hasLowStock = !!document.querySelector('.cart__items [data-low-stock]');
    notice.hidden = !hasLowStock;
  }

  document.addEventListener('ajaxProduct:added', updateReservationNotice);
  document.addEventListener('cart:updated', updateReservationNotice);
  document.addEventListener('cart:open', updateReservationNotice);
  document.addEventListener('DOMContentLoaded', updateReservationNotice);
  if (document.readyState !== 'loading') updateReservationNotice();
})();
